import { Save } from 'lucide-react'
import { saveToSlot } from '@/systems/SaveSystem'
import { EventBus, GameEvents } from '@/game/utils/EventBus'

export type SaveVariant = 'header' | 'menu'

/** One-tap quick save into slot 1, with toast feedback. Autosave already runs
 *  continuously; this gives the player a visible, reassuring manual save. */
export function quickSave() {
  const meta = saveToSlot(1)
  EventBus.emit(GameEvents.NOTIFY, {
    message: meta ? 'Partida guardada' : 'No se pudo guardar la partida',
    type: meta ? 'success' : 'error',
  })
}

interface QuickSaveButtonProps {
  variant: SaveVariant
  onDone?: () => void
}

export function QuickSaveButton({ variant, onDone }: QuickSaveButtonProps) {
  const handleClick = () => {
    quickSave()
    onDone?.()
  }

  if (variant === 'menu') {
    return (
      <button
        onClick={handleClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          padding: '0.6rem 0.7rem',
          clipPath: 'var(--angle-clip)',
          border: 'none',
          cursor: 'pointer',
          // Green (action), not gold — so it isn't mistaken for an active nav tab
          background: 'color-mix(in srgb, var(--success) 16%, transparent)',
          color: 'var(--success)',
          fontSize: '0.8rem',
          fontWeight: 600,
        }}
      >
        <Save size={18} /> Guardar
      </button>
    )
  }

  // header
  return (
    <button
      onClick={handleClick}
      title="Guardar partida"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.35rem',
        padding: '0.34rem 0.65rem',
        clipPath: 'var(--angle-clip)',
        border: 'none',
        cursor: 'pointer',
        background: 'color-mix(in srgb, var(--success) 16%, transparent)',
        color: 'var(--success)',
        fontFamily: 'var(--font-titles)',
        fontWeight: 700,
        fontSize: '0.8rem',
        letterSpacing: '0.02em',
      }}
    >
      <Save size={14} /> Guardar
    </button>
  )
}
